import { ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StateChange } from 'ng-lazyload-image';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { OmnialMedia } from 'src/@omnial/_models/catalog/omnial-media.model';
import { AppSettings } from 'src/app/app.settings';

@Component({
    selector: 'app-product-zoom',
    templateUrl: './../../../../app/pages/product/product-zoom/product-zoom.component.html',
    styleUrls: ['./../../../../app/pages/product/product-zoom/product-zoom.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class ProductZoomComponent {
  public zoomLevel;
  public imageWidth = '';
  public blurr = false;
  public width: number;
  public height: number;
  public zoomWidth: number;
  public zoomHeight: number;
  public zoomTimer: NodeJS.Timeout;
  public initialized = false;

  constructor(
    public dialogRef: MatDialogRef<ProductZoomComponent>,
    @Inject(MAT_DIALOG_DATA) public image: OmnialMedia,
    public settings: AppSettings,
    public spinner: NgxSpinnerService,
    public cd: ChangeDetectorRef,
    public toastr: ToastrService) { }

  public close(): void {
    this.dialogRef.close();
  }

  public zoomIn(zoomLevel: number): void {
    if (this.zoomLevel > 500) {
      this.toastr.warning("Maximum zoom reached");
    } else {
      this.changeZoom(this.zoomLevel + zoomLevel);
    }
  }

  public zoomOut(zoomLevel: number): void {
    if (this.zoomLevel < 30) {
      this.toastr.warning("Minimum zoom reached");
    } else {
      this.changeZoom(this.zoomLevel - zoomLevel)
    }
  }

  public changeZoom(zoomLevel: number): void {
    this.zoomLevel = zoomLevel;
    this.zoomWidth = (this.zoomLevel / 100) * this.width;
    this.zoomHeight = (this.zoomLevel / 100) * this.height;
    this.imageWidth = this.zoomWidth.toString() + 'px';
    if (this.zoomWidth > this.width) {
      this.blurr = true;
    } else {
      this.blurr = false;
    }
    const img = document.getElementById('zoomImage') as HTMLImageElement;
    this.setScroll(img, false);
  }

  public imageStateChange(event: StateChange): void {
    if (event?.reason === 'finally') {
      const img = document.getElementById('zoomImage') as HTMLImageElement;
      if (img) {
        this.setScroll(img, true);
      }
    }
  }

  private setScroll(img: HTMLImageElement, initial: boolean): void {
    if (this.zoomTimer) {
      clearTimeout(this.zoomTimer);
    }
    const container = document.getElementById('zoomContainer') as HTMLElement;
    if (container) {
      if (initial && (img.clientWidth !== img.naturalWidth)) { // Event Finally may not have the correct image yet ... so we HACK it here with a timeout
        this.zoomTimer = setTimeout(() => { this.setScroll(img, true); }, 100);
        return;
      }
      if (initial) {
        this.width = img.clientWidth;
        this.height = img.clientHeight;
        if (img.clientWidth / 4 > container.clientWidth) {
          this.changeZoom(20);
        } else if (img.clientWidth / 3 > container.clientWidth) {
          this.changeZoom(30);
        } else if (img.clientWidth / 2 > container.clientWidth) {
          this.changeZoom(50);
        } else {
          this.changeZoom(100);
        }
        this.initialized = true;
        setTimeout(() => { container.click(); this.cd.detectChanges(); }, 200); // HACK - Testing required
        return;
      }
      let scrollX = 0;
      let scrollY = 0;
      if (this.zoomWidth > container.clientWidth) {
        scrollX = (this.zoomWidth - container.clientWidth) / 2;
      }
      if (this.zoomHeight > container.clientHeight) {
        scrollY = (this.zoomHeight - container.clientHeight) / 2;
      }
      container.scrollTo(scrollX, scrollY);
    }
    this.cd.detectChanges();
  }

  public formatLabel(value: number): string {
    return `${value}%`;
  }

}
